<template>
    <ul class="navbar-nav">
        <li class="nav-item" v-if="!roles.Guest">
            <router-link to="/dashboard" class="nav-link">
                <div class="me-3 ms-2 text-primary">
                    <i class="fa fa-home"></i>
                    <font-awesome-icon icon="home" />
                </div>
                <span class="nav-link-text ms-1">Dashboard</span>
            </router-link>
        </li>
        <li class="nav-item mt-3">
            <h6 class="px-4 text-uppercase text-truncate text-xs font-weight-bolder opacity-6">Pengujian</h6>
        </li>
        <li class="nav-item">
            <router-link to="/ujilab-pengajuan" class="nav-link" v-if="roles.Guest">
                <div class="ms-3 me-3 text-primary">
                    <font-awesome-icon icon="flask" />
                </div>
                <span class="nav-link-text ms-1">Pengajuan</span>
            </router-link>
            <router-link to="/ujilab-penerimaan" class="nav-link" v-if="roles.Operator || roles.Administrator">
                <div class="ms-3 me-3 text-primary">
                    <font-awesome-icon icon="flask" />
                </div>
                <span class="nav-link-text ms-1">Penerimaan</span>
            </router-link>
            <router-link to="/ujilab-pengujian" class="nav-link" v-if="roles.Operator || roles.Administrator">
                <div class="ms-3 me-3 text-primary">
                    <font-awesome-icon icon="flask" />
                </div>
                <span class="nav-link-text ms-1">Pengujian</span>
            </router-link>
        </li>
        <li class="nav-item mt-3">
            <h6 class="px-4 text-uppercase text-truncate text-xs font-weight-bolder opacity-6">Penyewaan</h6>
        </li>
        <li class="nav-item">
            <router-link to="/penyewaan-pengajuan-create" class="nav-link" v-if="roles.Guest">
                <div class="ms-3 me-3 text-primary">
                    <font-awesome-icon icon="snowplow" />
                </div>
                <span class="nav-link-text ms-1">Pengajuan</span>
            </router-link>
            <router-link to="/penyewaan-master-alat-berat" class="nav-link" v-if="roles.Operator">
                <div class="ms-3 me-3 text-primary">
                    <font-awesome-icon icon="snowplow" />
                </div>
                <span class="nav-link-text ms-1">Alat Berat</span>
            </router-link>
            <router-link to="/penyewaan-pengajuan" class="nav-link" v-if="roles.Operator || roles.Administrator">
                <div class="ms-3 me-3 text-primary">
                    <font-awesome-icon icon="hand-holding" />
                </div>
                <span class="nav-link-text ms-1">Penyewaan</span>
            </router-link>
        </li>
    </ul>
</template>

<script>
export default {
    name: 'Sidebar',
    props: {
        roles: Object
    }
}
</script>